import { Component } from "../../../component-decorator";
import { StateService } from "@uirouter/core";
import { Input } from "@angular/core";

@Component({
  componentName: "appIntegrationPopover",
  controllerAs: "$ctrl",
  template: require("./integration-popover.html"),
})
export class IntegrationPopoverComponent implements angular.IController {
  @Input()
  private tour = false;

  public providers = [];

  constructor(
    private $state: StateService,
    private $uibModal,
    private localStorageService,
    private IntegrationService,
    private Perfil
  ) {}

  public async $onInit() {
    try {
      const data = await this.Perfil.getBetaFeatures();
      const permissoes = data.funcionalidades;
      this.providers = this.IntegrationService.getEnabledProviders(permissoes);

      await this.IntegrationService.tryAuthorizeAccountsBatch(this.providers);
    } catch (e) {
      console.error("Error: Beta features service");
    }
  }

  importSales(provider) {
    if (provider.slug === "mercadolivre") {
      this._importFromMeli(provider);
      return;
    }

    if (provider.isAuthorized) {
      this.$state.go("import-sales", {
        provider: provider.slug,
        tour: this.tour,
      });
    } else {
      this.IntegrationService.connect(provider, true);
    }
  }

  exibirModalMl() {
    this.$uibModal.open({
      animation: false,
      windowClass: "modal-mercado-livre",
      template: require("./mercado-livre.html"),
      controller: "ModalMercadoLivreCtrl as vmML",
      resolve: {
        primeiraVez: false,
      },
    });
  }

  private async _importFromMeli(meliObj) {
    if (this.localStorageService.cookie.get("primeiraVezML") === null) {
      const modalInstance = this.$uibModal.open({
        animation: false,
        windowClass: "modal-mercado-livre modal-primeira-vez-mercado-livre",
        template: require("./mercado-livre.html"),
        controller: "ModalMercadoLivreCtrl as vmML",
        backdrop: "static",
        resolve: {
          primeiraVez: true,
        },
      });

      await modalInstance.result;
    }

    this.initiateMLImport(meliObj);
  }

  private initiateMLImport(meliObj) {
    if (meliObj.isAuthorized) {
      this.$state.go("importar", { tour: this.tour });
    } else {
      this.IntegrationService.connect(meliObj, true);
    }
  }
}
